var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconChewronForward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09061 11.7842C5.9698 11.9033 5.9698 12.0967 6.09061 12.2158L13.8981 19.9111C14.0184 20.0296 14.2129 20.0296 14.3331 19.9111L15.4094 18.8503C15.5302 18.7312 15.5302 18.5378 15.4094 18.4187L9.04308 12.1439C8.96254 12.0645 8.96254 11.9355 9.04308 11.8561L15.4094 5.58132C15.5302 5.46224 15.5302 5.26875 15.4094 5.14967L14.3331 4.08888C14.2129 3.97037 14.0184 3.97037 13.8981 4.08888L6.09061 11.7842Z",
    fill: "#ADBFDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewronLeft);
export default __webpack_public_path__ + "static/media/iconChewronLeft.a512aa95514a6a68e4f20fff3dcf9618.svg";
export { ForwardRef as ReactComponent };